// Search-param schema for the three legacy browse routes (`/birthday/browse`,
// `/anniversary/browse`, `/holiday/browse`). Lives in its own dependency-free
// module so the ROUTE STUBS can import it: a runtime import from the (731-line)
// page module defeats the router's component code-splitting and drags the whole
// browse tree into the entry chunk.
import { UUID_SHAPE_RE } from "@shared/validation";

export type BrowseSearch = {
  reminder_id?: string;
  lcid?: string;
  category_id?: string;
  explainer?: string;
  birthday_list_id?: string;
};

export const validateBrowseSearch = (search: Record<string, unknown>): BrowseSearch => ({
  reminder_id:
    typeof search.reminder_id === "string" && search.reminder_id ? search.reminder_id : undefined,
  // Legacy reminder-mail links (PRD 13 D18 addendum): the patched legacy mailer
  // sends `lcid=<legacy calendar_id>` next to its own `r=`; we resolve it to
  // `reminder_id` on landing. (It is deliberately NOT named `calendar_id`: legacy's
  // own browse page branches on that key to a cookie-only endpoint, which breaks
  // soft-login clicks there.) Legacy's `r`, `t`, `e`, `tcid`, `ccid` are ignored.
  // TanStack's default parseSearch JSON-parses each value, so a bare numeric `lcid` arrives
  // as a NUMBER, not a string (cutover night 2026-10-21: every legacy reminder link fell
  // out to /cards). Accept both and normalise to the digit string.
  lcid:
    (typeof search.lcid === "string" || typeof search.lcid === "number") &&
    /^\d{1,15}$/.test(String(search.lcid))
      ? String(search.lcid)
      : undefined,
  // Land in this category instead of the reminder's scoped root (reminder emails: the
  // milestone mail's START A GROUP CARD → the birthday group-cards category).
  category_id:
    typeof search.category_id === "string" && UUID_SHAPE_RE.test(search.category_id)
      ? search.category_id
      : undefined,
  // Legacy `?explainer=` popup trigger (reminder emails' gift-card promos send
  // `explainer=gift-cards`): opens the gift-card explainer once, then is stripped.
  explainer: search.explainer ? String(search.explainer) : undefined,
  // PRD 16 §6.3: the reminder email for a synced birthday ("Start a group card with the <list>
  // list") and the list page's group-card button. Forwarded to the composer, whose signers
  // step then offers the list's other members.
  birthday_list_id:
    typeof search.birthday_list_id === "string" && UUID_SHAPE_RE.test(search.birthday_list_id)
      ? search.birthday_list_id
      : undefined,
});
